import { $wp } from "@/services/wordpress/wp-api";

export function wpApiPlugin() {
    return {
        $wp: $wp
    }
}